module.exports = __webpack_public_path__ + "img/ar20.3e6beb6b.jpg";